import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

export const utilityCostFields: Record<
  string,
  FieldMetadataMessageDescriptorDef
> = {
  cost_quantity: {
    displayName: msg({
      message: 'Cost',
      context: 'The total cost of the utility',
    }),
    externalDescription: msg({
      message: 'The total cost of the utility in the specified currency.',
      context: 'Cost quantity',
    }),
  },
  cost_currency: {
    displayName: msg({
      message: 'Cost currency',
      context: 'The currency of the utility cost',
    }),
    externalDescription: msg({
      message: 'ISO 4217 currency code for the cost (e.g. USD, EUR, GBP).',
      context: 'Cost currency',
    }),
  },
};
